import { BoardUser, NCNode } from '../../../../src/commonTypes';

const USER_LIKE_PREFIX = 'user:';

export const nodeUserLikeKey = (userId: string): string => `${USER_LIKE_PREFIX}${userId}`;

export const isNodeLikedByUser = (node: NCNode, user: BoardUser): boolean =>
	Boolean(node.likes?.[nodeUserLikeKey(user.id)] || node.likes?.[user.colour]);

export const getNodeLikeActionLabel = (node: NCNode, user: BoardUser): 'Like' | 'Unlike' =>
	isNodeLikedByUser(node, user) ? 'Unlike' : 'Like';

export const getNodeLikers = (node: NCNode, boardUsers: BoardUser[]): BoardUser[] =>
	boardUsers.filter((user) => isNodeLikedByUser(node, user));

export const withNodeLikeState = (
	node: NCNode,
	user: BoardUser,
	liked: boolean
): NCNode => {
	const likes = { ...(node.likes || {}) };
	const userKey = nodeUserLikeKey(user.id);
	// Remove the old colour-only flag when this user next reacts. The explicit
	// user key remains independent even if board colours are later reassigned.
	delete likes[user.colour];
	if (liked) likes[userKey] = true;
	else delete likes[userKey];
	return { ...node, likes };
};
